import { useContext, useEffect, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import ApiContext from "src/provider/API/call-service"
import UserContext from "src/provider/state-manager/userProvider"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { AppSpan, AppText, Button, CustomContainer, FlexColumn, FlexRow, Form, FormGroup, FormGroupWithIcon, ScreenTitle } from "src/style"
import { LimitUpgradeIndemnity, RadioSelection, TxPinVerification } from "src/component"
import utility, { handleAmountChange, moneyFormat } from "src/utils/utility"
import { FiChevronDown } from "react-icons/fi"

export const ManageTransactionLimit: React.FC<any> = ({close}) => {
    const {API} = useContext(ApiContext)
    const {user: {accountInfo, accountWithBalanceDetails}} = useContext(UserContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const [singleTrxLimit,setSingleTrxLimit] = useState("")
    const [dailyTrxLimit, setDailyTrxLimit] = useState("")
    const [input, setInput] = useState({
        currentDailyLimit: '', currentOneTimeLimit: '', dailyTransactionLimit: dailyTrxLimit, 
        oneTimeTransactionLimit: singleTrxLimit, pin: '', accountNumber: accountWithBalanceDetails[0]?.nuban || accountWithBalanceDetails[0]?.number
    })
    const [txLimitType, setTxLimitType] = useState('')
    const [view, setView] = useState('set-tx-limit')

    useEffect(() => {
        handleFetchTxLimit()
    }, [])

    async function handleFetchTxLimit () {
        const response = await API.getTransactionLimit(accountWithBalanceDetails[0]?.nuban || accountWithBalanceDetails[0]?.number)
        if (response) setInput({...input, currentDailyLimit: String(response.dailyLimit), currentOneTimeLimit: String(response.oneTimeLimit)})
    }

    // const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
    //     let val = e.target.value.replace(/,/g, '')
    //     if (!isNaN(Number(val))) {
    //         setInput({...input, [e.target.name]: val})
    //     }
    // }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (institutionData?.useIdemityForAccountLimitChange) setView('indemnity-form')
        else setView('pin')
    }

    async function handleSubmit() {
        const payload = {...input}
        payload.dailyTransactionLimit = payload.dailyTransactionLimit || input.currentDailyLimit
        payload.oneTimeTransactionLimit = payload.oneTimeTransactionLimit || input.currentOneTimeLimit
        
        await API.updateTransactionLimit(payload)
        close()
    }

    return (
        <>
            { view === 'set-tx-limit' &&
                <SidePopupLayout close={close}>
                    <ScreenTitle textSize="2.2" fontWeight="700">Manage Transaction Limit</ScreenTitle>
                    <CustomContainer topMargin='2.5'>
                        <Form onSubmit={handleProceed}>
                            <FormGroupWithIcon bottomMargin='2'>
                                <label>Select Source Account</label>
                                <div className='input-with-icon'>
                                    <select 
                                        name='accountNumber'
                                        value={input.accountNumber}
                                        style={{color: input.accountNumber ? '#000000' : '#667085'}}
                                        onChange={(e) => setInput({...input, accountNumber: e.target.value})}
                                        disabled={accountWithBalanceDetails?.length === 1}
                                        required
                                    >
                                        {
                                            accountWithBalanceDetails?.map((item: any, index: number) => {
                                                return (
                                                    <option 
                                                        value={item.nuban} 
                                                        key={index}
                                                    >
                                                        {item.nuban} - ({moneyFormat(item?.balance?.withdrawableAmount,institutionData?.defaultCurrency)})
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FormGroup>
                                <RadioSelection 
                                    options={['Single', 'Daily']}
                                    noDefault
                                    output={(val: any) => setTxLimitType(val)} 
                                />
                            </FormGroup>
                            { txLimitType &&
                                <>
                                    <FlexColumn 
                                        bottomMargin="2" minHeight="4.1" padding="1"
                                        bgColor="#E7F6F5" radius="0.8" alignItems="flex-start"
                                        leftPadding="2" rightPadding="2"
                                    >
                                        <AppText textSize="1.2" color="#0A756F" >
                                            Current {txLimitType} Transaction Limit is
                                            <AppSpan leftMargin="0.5" fontWeight="700" textSize="1.2" color="#0A756F">
                                            {moneyFormat(txLimitType === 'Single' ? input.currentOneTimeLimit : input.currentDailyLimit,institutionData?.defaultCurrency)}
                                            </AppSpan>
                                        </AppText>
                                    </FlexColumn>
                                    { txLimitType === 'Daily' ?
                                        <FormGroup>
                                            <label>New Daily Transaction Limit</label>
                                            <input 
                                                placeholder='Enter Amount' 
                                                name='dailyTransactionLimit'
                                                value={dailyTrxLimit}
                                                onChange={(e)=> handleAmountChange(e.target.value,"input", setDailyTrxLimit,setInput,input,e.target.name)}
                                                autoComplete="off"
                                                required
                                            />
                                        </FormGroup>
                                        :
                                        <FormGroup>
                                            <label>New Single Transaction Limit</label>
                                            <input 
                                                placeholder='Enter Amount' 
                                                name='oneTimeTransactionLimit'
                                                value={singleTrxLimit}
                                                onChange={(e)=> handleAmountChange(e.target.value,"input", setSingleTrxLimit,setInput,input,e.target.name)}
                                                autoComplete="off"
                                                required
                                            />
                                        </FormGroup>
                                    }
                                    <FlexRow justifyContent='flex-end' topMargin='2.5'>
                                        <Button 
                                            width='8.8' height='4' 
                                            borderColor='#0D968F' hoverBgColor='#fff' 
                                            hoverColor='#0D968F' titleSize='1.4'
                                        >
                                            Proceed
                                        </Button>
                                    </FlexRow>
                                </>
                            }
                        </Form>
                    </CustomContainer>
                </SidePopupLayout>
            }
            { view === 'pin' &&
                <TxPinVerification
                    close={() => setView('set-tx-limit')}
                    onPinChange={(pin: string) => setInput({...input, pin})}
                    next={handleSubmit} 
                />
            }
            { view === 'indemnity-form' &&
                <LimitUpgradeIndemnity
                    nuban={input.accountNumber}
                    close={close} 
                    next={() => setView('pin')}
                    back={() => setView('set-tx-limit')}
                />
            }
        </>
    )
}